// extracted by mini-css-extract-plugin
module.exports = {"expandingAreaWrapper":"_ea633ddf"};